/**
 * Buy Box V11 - V2 Clone + Cookie-Based Countdown Timer
 * 
 * FUNCTIONALITY:
 * - Gallery navigation (arrows, thumbnails, swipe, keyboard)
 * - Plan selection (single, double, one-time)
 * - Dynamic perk text updates
 * - Add to cart with Skio/Recharge selling plans
 * - Cookie-based countdown timer (duration from first visit)
 */

(function() {
  'use strict';

  // Initialize all buy boxes on the page
  function init() {
    document.querySelectorAll('.buy-box-v11').forEach(initBuyBox);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function(e) {
    var section = e.target;
    if (section) {
      var boxes = section.querySelectorAll('.buy-box-v11');
      if (boxes.length > 0) {
        boxes.forEach(initBuyBox);
      }
    }
  });

  function initBuyBox(container) {
    if (container._bb11Initialized) return;
    container._bb11Initialized = true;

    initGallery(container);
    initPlanSelection(container);
    initSocialProofScroll(container);
    initCountdown(container);
    initPromoBar(container);
  }

  /* ========== Social Proof Scroll ========== */
  function initSocialProofScroll(container) {
    var socialProof = container.querySelector('.buy-box-v11__social-proof--clickable');
    if (!socialProof) return;

    var reviewsId = socialProof.dataset.reviewsId;
    if (!reviewsId) return;

    socialProof.addEventListener('click', function(e) {
      e.preventDefault();
      var el = document.getElementById(reviewsId);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  /* ========== Countdown Timer ========== */
  function initCountdown(container) {
    var el = container.querySelector('.buy-box-v11__countdown');
    if (!el) return;

    var endDateStr = el.dataset.countdownEnd;
    var template = el.dataset.countdownTemplate || '';
    var boldValues = el.dataset.countdownBoldValues === 'true';

    if (!template || !endDateStr) {
      el.style.display = 'none';
      return;
    }

    var endTime = new Date(endDateStr).getTime();
    if (isNaN(endTime)) {
      el.style.display = 'none';
      return;
    }

    function formatVal(num, singular, plural) {
      var str = num + ' ' + (num === 1 ? singular : plural);
      if (boldValues) {
        return '<span class="buy-box-v11__countdown-bold">' + str + '</span>';
      }
      return str;
    }

    function update() {
      var now = Date.now();
      var remaining = endTime - now;

      if (remaining <= 0) {
        el.setAttribute('data-expired', 'true');
        return;
      }

      var days = Math.floor(remaining / (1000 * 60 * 60 * 24));
      var hours = Math.floor((remaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((remaining % (1000 * 60)) / 1000);

      var text = template
        .replace(/{days}/g, formatVal(days, 'day', 'days'))
        .replace(/{hours}/g, formatVal(hours, 'hour', 'hours'))
        .replace(/{minutes}/g, formatVal(minutes, 'minute', 'minutes'))
        .replace(/{seconds}/g, formatVal(seconds, 'second', 'seconds'));

      el.innerHTML = text;
      requestAnimationFrame(function() {
        setTimeout(update, 1000);
      });
    }

    update();
  }

  /* ========== Promo Bar ========== */
  function initPromoBar(container) {
    var promoBar = container.querySelector('.buy-box-v11__promo-bar');
    if (!promoBar) return;

    // Store ref so gallery nav can toggle it
    container._bb11PromoBar = promoBar;
  }

  function updatePromoBar(container, imageIndex) {
    var bar = container._bb11PromoBar;
    if (!bar) return;
    if (imageIndex === 0) {
      bar.classList.remove('buy-box-v11__promo-bar--hidden');
    } else {
      bar.classList.add('buy-box-v11__promo-bar--hidden');
    }
  }

  /* ========== Gallery ========== */
  function initGallery(container) {
    var gallery = container.querySelector('.buy-box-v11__gallery');
    if (!gallery) return;

    var images = gallery.querySelectorAll('.buy-box-v11__gallery-image');
    var thumbnails = gallery.querySelectorAll('.buy-box-v11__thumbnail');
    var prevBtn = gallery.querySelector('.buy-box-v11__gallery-arrow--prev');
    var nextBtn = gallery.querySelector('.buy-box-v11__gallery-arrow--next');
    var counter = gallery.querySelector('.buy-box-v11__gallery-current');

    if (images.length === 0) return;

    var currentIndex = 0;

    function showImage(index) {
      if (index < 0) index = images.length - 1;
      if (index >= images.length) index = 0;

      currentIndex = index;

      images.forEach(function(img, i) {
        img.classList.toggle('buy-box-v11__gallery-image--active', i === currentIndex);
      });

      thumbnails.forEach(function(thumb, i) {
        thumb.classList.toggle('buy-box-v11__thumbnail--active', i === currentIndex);
      });

      if (counter) {
        counter.textContent = currentIndex + 1;
      }

      updatePromoBar(container, currentIndex);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        showImage(currentIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        showImage(currentIndex + 1);
      });
    }

    thumbnails.forEach(function(thumb) {
      thumb.addEventListener('click', function(e) {
        e.preventDefault();
        var index = parseInt(this.dataset.index, 10);
        showImage(index);
      });
    });

    gallery.addEventListener('keydown', function(e) {
      if (e.key === 'ArrowLeft') showImage(currentIndex - 1);
      else if (e.key === 'ArrowRight') showImage(currentIndex + 1);
    });

    var touchStartX = 0;
    var galleryMain = gallery.querySelector('.buy-box-v11__gallery-main');
    if (galleryMain) {
      galleryMain.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      galleryMain.addEventListener('touchend', function(e) {
        var diff = touchStartX - e.changedTouches[0].screenX;
        if (Math.abs(diff) > 50) {
          diff > 0 ? showImage(currentIndex + 1) : showImage(currentIndex - 1);
        }
      }, { passive: true });
    }
  }

  /* ========== Plan Selection ========== */
  function initPlanSelection(container) {
    var allPlans = container.querySelectorAll('.buy-box-v11__plan');
    var subscriptionPlans = container.querySelectorAll('.buy-box-v11__plan:not(.buy-box-v11__plan--onetime)');
    var onetimePlan = container.querySelector('.buy-box-v11__plan--onetime');
    var perkWithVariants = container.querySelector('.buy-box-v11__perk[data-perk-single]');
    var primaryCta = container.querySelector('.buy-box-v11__cta--primary');

    var variantId = container.dataset.variantId;
    var sellingPlanId = container.dataset.sellingPlanId;
    var hasSellingPlan = container.dataset.hasSellingPlan === 'true';

    function updatePrimaryCtaState() {
      if (!primaryCta) return;
      var isOnetimeSelected = onetimePlan && onetimePlan.classList.contains('buy-box-v11__plan--selected');
      if (isOnetimeSelected) {
        primaryCta.classList.add('buy-box-v11__cta--faded');
      } else {
        primaryCta.classList.remove('buy-box-v11__cta--faded');
      }
    }

    subscriptionPlans.forEach(function(plan) {
      plan.addEventListener('click', function() {
        allPlans.forEach(function(p) {
          p.classList.remove('buy-box-v11__plan--selected');
        });
        this.classList.add('buy-box-v11__plan--selected');
        updatePrimaryCtaState();

        var planType = this.dataset.plan;
        if (perkWithVariants) {
          var perkText = planType === 'double'
            ? perkWithVariants.dataset.perkDouble
            : perkWithVariants.dataset.perkSingle;
          var textSpan = perkWithVariants.querySelector('span');
          if (textSpan && perkText) {
            textSpan.textContent = perkText;
          }
        }
      });
    });

    if (onetimePlan) {
      onetimePlan.addEventListener('click', function(e) {
        if (e.target.closest('.buy-box-v11__cta--secondary')) return;

        subscriptionPlans.forEach(function(p) {
          p.classList.remove('buy-box-v11__plan--selected');
        });
        onetimePlan.classList.add('buy-box-v11__plan--selected');
        updatePrimaryCtaState();
      });

      var onetimeCta = onetimePlan.querySelector('.buy-box-v11__cta--secondary');
      if (onetimeCta) {
        onetimeCta.addEventListener('click', function(e) {
          e.stopPropagation();
          if (variantId) {
            addToCart(variantId, 1, null);
          } else {
            console.error('Buy Box V11: No variant ID found for one-time purchase');
          }
        });
      }
    }

    if (primaryCta) {
      primaryCta.addEventListener('click', function(e) {
        e.preventDefault();
        var isOnetimeSelected = onetimePlan && onetimePlan.classList.contains('buy-box-v11__plan--selected');

        if (isOnetimeSelected) {
          if (subscriptionPlans.length > 0) {
            allPlans.forEach(function(p) {
              p.classList.remove('buy-box-v11__plan--selected');
            });
            subscriptionPlans[0].classList.add('buy-box-v11__plan--selected');
            updatePrimaryCtaState();
          }
          return;
        }

        var selectedSubscription = container.querySelector('.buy-box-v11__plan--selected:not(.buy-box-v11__plan--onetime)');
        if (selectedSubscription) {
          var quantity = parseInt(selectedSubscription.dataset.quantity, 10) || 1;
          if (variantId) {
            if (hasSellingPlan && sellingPlanId) {
              addToCart(variantId, quantity, sellingPlanId);
            } else {
              addToCart(variantId, quantity, null);
            }
          } else {
            console.error('Buy Box V11: No variant ID found');
          }
        }
      });
    }
  }

  /* ========== Add to Cart ========== */
  function addToCart(variantId, quantity, sellingPlanId) {
    if (!variantId) return;

    var item = {
      id: parseInt(variantId, 10),
      quantity: quantity
    };

    if (sellingPlanId) {
      item.selling_plan = parseInt(sellingPlanId, 10);
    }

    var ctaButtons = document.querySelectorAll('.buy-box-v11 .buy-box-v11__cta');
    ctaButtons.forEach(function(btn) {
      btn.classList.add('buy-box-v11__cta--loading');
      btn.disabled = true;
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: [item] })
    })
    .then(function(response) {
      if (!response.ok) {
        return response.json().then(function(err) {
          throw new Error(err.message || err.description || 'Failed to add to cart');
        });
      }
      return response.json();
    })
    .then(function(data) {
      console.log('Buy Box V11: Added to cart', data);
      ctaButtons.forEach(function(btn) {
        btn.classList.remove('buy-box-v11__cta--loading');
        btn.disabled = false;
      });
      openCartDrawer();
    })
    .catch(function(error) {
      console.error('Buy Box V11: Error adding to cart', error);
      ctaButtons.forEach(function(btn) {
        btn.classList.remove('buy-box-v11__cta--loading');
        btn.disabled = false;
      });
      alert('Error: ' + error.message);
    });
  }

  /* ========== Open Cart Drawer ========== */
  function openCartDrawer() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:open'));
    document.dispatchEvent(new CustomEvent('theme:cart:open'));

    var cartTriggers = [
      '[data-cart-trigger]',
      '.js-cart-trigger',
      '.cart-icon',
      '[data-action="open-drawer"][data-drawer="cart"]',
      '#cart-icon',
      '.header__icon--cart',
      '[href="/cart"]'
    ];

    var drawerOpened = false;

    for (var i = 0; i < cartTriggers.length; i++) {
      var trigger = document.querySelector(cartTriggers[i]);
      if (trigger && typeof trigger.click === 'function') {
        var isDrawerTrigger =
          trigger.hasAttribute('data-cart-trigger') ||
          trigger.hasAttribute('data-action') ||
          trigger.classList.contains('js-cart-trigger');

        if (isDrawerTrigger) {
          trigger.click();
          drawerOpened = true;
          break;
        }
      }
    }

    var drawerSelectors = [
      '.cart-drawer', '#cart-drawer', '.drawer--cart',
      '[data-drawer="cart"]', '.mini-cart', '.cart-flyout'
    ];

    for (var j = 0; j < drawerSelectors.length; j++) {
      var drawer = document.querySelector(drawerSelectors[j]);
      if (drawer) {
        drawer.classList.add('is-open', 'active', 'open');
        drawerOpened = true;
        var overlay = document.querySelector('.drawer-overlay, .cart-overlay');
        if (overlay) {
          overlay.classList.add('is-open', 'active');
        }
        break;
      }
    }

    if (!drawerOpened) {
      setTimeout(function() {
        var visible = document.querySelector(
          '.cart-drawer.is-open, .drawer--cart.active, [data-drawer="cart"].open'
        );
        if (!visible) {
          window.location.href = '/cart';
        }
      }, 300);
    }
  }

})();
